import { sendContainerRequest } from '@/container'

type DeleteSubAccountPayload = {
    subAccountId: string
}

export type DeleteSubAccountResponse = {
    success: boolean
    error?: string
}

export async function deleteSubAccount(
    payload: DeleteSubAccountPayload
): Promise<DeleteSubAccountResponse> {
    return sendContainerRequest('deleteSubAccountByUser', payload)
        .then((result) => {
            return result.data
        })
        .catch((err) => ({ success: false, error: err }))
}
